(function(global) {
    'use strict';
  
    var lib = global.lib || (global.lib = {}),
        mms = global.mms || (global.mms = {}),
        cjs = global.createjs || (global.createjs = {});
    
    function Frame() {
        this.__parent__.apply(this, arguments);
        
        this._addListeners();
    }
    Frame.prototype = {
        _addListeners: function() {
            this.on("added", this._added, this);
        },
        _added: function() {
            if (!this.painting) {
                this.painting = this.parent.parent.painting;

                var bounds = this.getBounds();
                mms.state.setZoomRect(this.painting, new cjs.Rectangle(
                    this.x - this.regX,
                    this.y - this.regY,
                    bounds.width,
                    bounds.height
                ));
            }
        }
    };
    
    var Frame_0 = _.extend({}, cjs.TouchMixin, {
        _addListeners: function() {
            Frame.prototype._addListeners.apply(this, arguments);
            mms.state.signals.changeHighlight.add(this._changeHighlight, this);
            mms.state.signals.changePainting.add(this._changePainting, this);
            this.initTouch();
        },
        onSwipeLeft: function() {
            if (!mms.state.rotated && mms.state.buttonsEnabled) {
                mms.state.setRotated(true);
            }
        },
        _added: function() {
            Frame.prototype._added.apply(this, arguments);
            if (typeof this.bmp === "undefined") {
                this.bmp = this.getChildAt(0);
                
                var bounds = this.getBounds();
                this._createOverlay(bounds.x, bounds.y, bounds.width, bounds.height);
                this._unhighlight(0);
            }
        },
        _createOverlay: function(x, y, width, height) {
            var shape = new cjs.Shape();
            shape.graphics.beginFill("#000000");
            shape.graphics.drawRect(x, y, width, height);
            shape.graphics.endFill();
            this.overlay = this.addChild(shape);
        },
        _changeHighlight: function(prevValue) {
            if (mms.state.highlight === this.painting) {
                this._highlight(mms.state.painting ? mms.Screen.TWEEN_DURATION : 1);
            }
            else if (prevValue === this.painting) {
                this._unhighlight(mms.state.painting ? mms.Screen.TWEEN_DURATION : 1);
            }
        },
        _unhighlight: function(duration, tintAmount) {
            TweenLite.to(this.overlay, duration, {alpha: 0.7, ease: Sine.easeOut});
            this._randomCrossFade(duration);
        },
        _highlight: function(duration) {
            TweenLite.to(this.overlay, duration, {alpha: 0, ease: Sine.easeOut});
            if (!mms.state.painting) {
                this._randomCrossFade(duration/2);
            }
        },
        _changePainting: function(prevValue) {
            if (mms.state.painting !== 0) {
                if (mms.state.painting === this.painting) {
                    this._completeCrossFade();
                    this._removeCrossFade();
                    var self = this;
                    TweenLite.to(this.bmp, mms.Screen.TWEEN_DURATION, {
                        x: 0,
                        y: 0,
                        scaleX: 1,
                        scaleY: 1,
                        onUpdate: function() {
                            self.overlay.x = self.bmp.x;
                            self.overlay.y = self.bmp.y;
                            self.overlay.scaleX = self.bmp.scaleX;
                            self.overlay.scaleY = self.bmp.scaleY;
                        }
                    });
                }
            }
        },
        _randomCrossFade: function(duration) {
            var randomX = -50+Math.random()*100,
                randomY = -50+Math.random()*100,
                randomScale = 0.75+Math.random()*0.5;
            this._crossFade(randomX, randomY, randomScale, duration);
        },
        _crossFade: function(x, y, scale, duration) {
            if (this.bmpClone) {
                this.removeChild(this.bmpClone);
            }
            this.bmpClone = this.bmp.clone(true);
            this.bmpClone.x = x;
            this.bmpClone.y = y;
            this.bmpClone.scaleX = scale;
            this.bmpClone.scaleY = scale;
            this.bmpClone.alpha = 0;
            this.addChildAt(this.bmpClone, 1);
            var self = this;
            TweenLite.to(this.bmpClone, duration, {
                alpha: 1,
                onComplete: _.bind(this._completeCrossFade, this)
            });
        },
        _completeCrossFade: function() {
            if (this.bmpClone) {
                this.bmp.x = this.bmpClone.x;
                this.bmp.y = this.bmpClone.y;
                this.bmp.scaleX = this.bmpClone.scaleX;
                this.bmp.scaleY = this.bmpClone.scaleY;
                this.overlay.x = this.bmp.x;
                this.overlay.y = this.bmp.y;
                this.overlay.scaleX = this.bmp.scaleX;
                this.overlay.scaleY = this.bmp.scaleY;
            }
        },
        _removeCrossFade: function() {
            TweenLite.killTweensOf(this.bmpClone);
            this.removeChild(this.bmpClone);
            delete this.bmpClone;
        }
    });

    var Frame_180 = _.extend({}, cjs.TouchMixin, {
        _addListeners: function() {
            Frame.prototype._addListeners.apply(this, arguments);
            this.initTouch();
        },
        onSwipeRight: function() {
            if (mms.state.rotated && mms.state.buttonsEnabled) {
                mms.state.setRotated(false);
            }
        }
    });

    lib.Frame1_0 = cjs.extend2(lib.Frame1_0, Frame, Frame_0);
    lib.Frame1_180 = cjs.extend2(lib.Frame1_180, Frame, Frame_180);
    lib.Frame2_0 = cjs.extend2(lib.Frame2_0, Frame, Frame_0);
    lib.Frame3_0 = cjs.extend2(lib.Frame3_0, Frame, Frame_0);
    lib.Frame3_180 = cjs.extend2(lib.Frame3_180, Frame, Frame_180);
    
    mms.Frame = Frame;
  
})(this);